import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'
import { Form, Col, Button } from '_zari/core'

import * as SeriesHistorialService from 'services/serieHistorial.service'

const SerieNumeroFormGroup = ({
  fIsSubmitting,
  handleBlur,
  vSerie,
  vTipoDocumento,
  vTipoOperacion,
  setFieldValue,
  iTouched,
  iError
}) => {
  const __zariContext = React.useContext(ZariContext)
  const [generandoCodigo, setGenerandoCodigo] = React.useState(false)

  const generarCodigoClickHandler = React.useCallback(() => {
    if (!vTipoDocumento) {
      __zariContext.snack('error', 'Selecciona el tipo de documento.')
      return
    }
    // La serie solo es obligatoria si el tipoDoc no es Otros/Ticket (00).
    const serieRequerida = vTipoDocumento !== '00'
    if (serieRequerida && (!vSerie || !vSerie.trim())) {
      __zariContext.snack('error', 'Ingresa primero la serie del documento.')
      return
    }
    setGenerandoCodigo(true)
    SeriesHistorialService.obtenerNuevoNumero({
      tipoDocumento: vTipoDocumento,
      serieDocumento: (vSerie || '').trim(),
      tipoOperacion: vTipoOperacion
    })
      .then(({ data }) => {
        // Backend devuelve { siguiente } (1 por defecto si no hay historial).
        // Soportamos `siguienteNumero` por retrocompat.
        const valor = data && (data.siguienteNumero != null ? data.siguienteNumero : data.siguiente)
        if (valor != null) {
          setFieldValue('numeroDocumento', valor)
        } else {
          // Si no llega nada (caso muy borde: 500 con cuerpo vacío), arrancamos en 1.
          setFieldValue('numeroDocumento', 1)
        }
      })
      .catch((err) => {
        __zariContext.snack('error', err?.data?.error || 'No se pudo generar el siguiente número')
      })
      .finally(() => setGenerandoCodigo(false))
  }, [vSerie, setFieldValue, vTipoDocumento, vTipoOperacion, __zariContext])

  return (
    <>
      <Form.Group>
        <Form.Label text='NUMERO DOCUMENTO' htmlFor='input-serieDocumento' md={4} alignRightAt='md' />
        <Col md={8}>
          <Form.InputGroup>
            <Field name='numeroDocumento'>
              {({ field }) => (
                <Form.InputNumber
                  {...field}
                  name='numeroDocumento'
                  id='input-numeroDocumento'
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button disabled={fIsSubmitting || generandoCodigo} color='secondary' onClick={generarCodigoClickHandler}>
                Generar
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
